// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.control {
  padding: 6px 14px;
}
.control div {
  padding: 6px 0;
}
.control h4 {
  border-bottom: 1px solid #ccc;
  margin: 12px 0 6px 0;
}
.control .skin-primary {
  width: 46px;
  height: 46px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}
.control .skin-primary .skin-secondary {
  width: 0;
  height: 0;
  padding: 0;
  border-bottom: 46px solid;
  border-left: 46px solid transparent;
}
.control .skin-primary.indigo-light {
  background-color: var(--color-primary-light);
  border: 1px solid var(--color-primary-light);
}
.control .skin-primary.indigo-light .skin-secondary {
  border-bottom-color: #ececec;
}
.control .skin-primary.teal-light {
  background-color: #009688;
  border: 1px solid #009688;
}
.control .skin-primary.teal-light .skin-secondary {
  border-bottom-color: #ececec;
}
.control .skin-primary.red-light {
  background-color: #F44336;
  border: 1px solid #F44336;
}
.control .skin-primary.red-light .skin-secondary {
  border-bottom-color: #ececec;
}
.control .skin-primary.gray-light {
  background-color: #757575;
  border: 1px solid #757575;
}
.control .skin-primary.gray-light .skin-secondary {
  border-bottom-color: #ececec;
}
.control .skin-primary.blue-dark {
  background-color: #0277bd;
  border: 1px solid #0277bd;
}
.control .skin-primary.blue-dark .skin-secondary {
  border-bottom-color: #262626;
}
.control .skin-primary.green-dark {
  background-color: #388E3C;
  border: 1px solid #388E3C;
}
.control .skin-primary.green-dark .skin-secondary {
  border-bottom-color: #262626;
}
.control .skin-primary.pink-dark {
  background-color: #D81B60;
  border: 1px solid #D81B60;
}
.control .skin-primary.pink-dark .skin-secondary {
  border-bottom-color: #262626;
}
.control .skin-primary.gray-dark {
  background-color: #607D8B;
  border: 1px solid #607D8B;
}
.control .skin-primary.gray-dark .skin-secondary {
  border-bottom-color: #262626;
}
.control .mat-radio-group,
.control .mat-mdc-radio-group {
  display: inline-flex;
  flex-direction: column;
}
.control .mat-radio-group .mat-radio-button,
.control .mat-radio-group .mat-mdc-radio-button,
.control .mat-mdc-radio-group .mat-radio-button,
.control .mat-mdc-radio-group .mat-mdc-radio-button {
  margin: 2px 0;
}
.control .mat-slide-toggle,
.control .mat-mdc-slide-toggle {
  height: auto;
}
.control .ps {
  height: calc(100% - 56px);
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/user-settings/user-settings.component.scss"],"names":[],"mappings":"AAIA;EACI,iBAAA;AAHJ;AAII;EACI,cAAA;AAFR;AAII;EACI,6BAAA;EACA,oBAAA;AAFR;AAII;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAGQ;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,mCAAA;AADZ;AAGQ;EACI,4CAAA;EACA,4CAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAGQ;EACI,yBAAA;EACA,yBAAA;AADZ;AAEY;EACI,4BAAA;AAAhB;AAKI;;EAEI,oBAAA;EACA,sBAAA;AAHR;AAIQ;;;;EAEI,aAAA;AAAZ;AAGI;;EAEI,YAAA;AADR;AAGI;EACI,yBAAA;AADR","sourcesContent":["// ==========================================================================\r\n// Component: User-settings.component\r\n// ==========================================================================\r\n@use \"../../theme/styles/variables\" as *;\r\n.control{\r\n    padding: 6px 14px;\r\n    div{\r\n        padding: 6px 0;\r\n    }\r\n    h4{\r\n        border-bottom: 1px solid #ccc;\r\n        margin: 12px 0 6px 0;\r\n    }\r\n    .skin-primary{\r\n        width: 46px;\r\n        height: 46px;\r\n        padding: 0;\r\n        overflow: hidden;            \r\n        cursor: pointer;  \r\n        .skin-secondary{\r\n            width: 0; \r\n            height: 0; \r\n            padding: 0;\r\n            border-bottom: 46px solid; \r\n            border-left: 46px solid transparent;\r\n        }\r\n        &.indigo-light{\r\n            background-color: var(--color-primary-light);\r\n            border: 1px solid var(--color-primary-light);\r\n            .skin-secondary{\r\n                border-bottom-color: #ececec;\r\n            }\r\n        }\r\n        &.teal-light{\r\n            background-color: #009688;\r\n            border: 1px solid #009688;\r\n            .skin-secondary{\r\n                border-bottom-color: #ececec;\r\n            }\r\n        }\r\n        &.red-light{\r\n            background-color: #F44336;\r\n            border: 1px solid #F44336;\r\n            .skin-secondary{\r\n                border-bottom-color: #ececec;\r\n            }\r\n        }\r\n        &.gray-light{\r\n            background-color: #757575;\r\n            border: 1px solid #757575;\r\n            .skin-secondary{\r\n                border-bottom-color: #ececec;\r\n            }\r\n        }\r\n        &.blue-dark{\r\n            background-color: #0277bd;\r\n            border: 1px solid #0277bd;\r\n            .skin-secondary{\r\n                border-bottom-color: #262626;\r\n            }\r\n        }\r\n        &.green-dark{\r\n            background-color: #388E3C;\r\n            border: 1px solid #388E3C;\r\n            .skin-secondary{\r\n                border-bottom-color: #262626;\r\n            }\r\n        }\r\n        &.pink-dark{\r\n            background-color: #D81B60;\r\n            border: 1px solid #D81B60;\r\n            .skin-secondary{\r\n                border-bottom-color: #262626;\r\n            }\r\n        }\r\n        &.gray-dark{\r\n            background-color: #607D8B;\r\n            border: 1px solid #607D8B;\r\n            .skin-secondary{\r\n                border-bottom-color: #262626;\r\n            }\r\n        }\r\n    }\r\n    \r\n    .mat-radio-group,\r\n    .mat-mdc-radio-group{\r\n        display: inline-flex;\r\n        flex-direction: column;\r\n        .mat-radio-button,\r\n        .mat-mdc-radio-button{\r\n            margin: 2px 0;\r\n        }\r\n    }\r\n    .mat-slide-toggle,\r\n    .mat-mdc-slide-toggle{\r\n        height: auto;\r\n    }\r\n    .ps{\r\n        height: calc(100% - #{$top-toolbar-height});\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
